import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { AddSectionComponent } from '../sections/add-section/add-section.component';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { HttpClient } from '@angular/common/http';
// import { SectionsService } from '../sections/sections.service';
import { DepartmentsService } from './departments.service';
import { DataTableDirective } from 'angular-datatables';
import { Section } from '../sections/sections.interface';
import { EditSectionComponent } from '../sections/edit-section/edit-section.component';
import Swal from 'sweetalert2';
import { AddDepartmentsComponent } from './add-departments/add-departments.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.scss'],
})
export class DepartmentsComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  isLoading = false;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  // selectedSectionOfDepartment: string = '';

  dtLink!: string;
  // environment.interop.basePath +
  // environment.interop.urbanism.nomenclatoare.cerereStatus.getCerereStatuses + '-dt';

  dataTablesParameters: any = {
    data: {
      key: 'parameter',
    },
  };

  constructor(
    private dialog: MatDialog,
    private http: HttpClient,
    private dialogService: DialogService,
    private departmentService: DepartmentsService
  ) {}

  ngOnInit(): void {
    this.renderDT();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next('');
  }

  openAddDialog() {
    const dialogRef = this.dialog.open(AddDepartmentsComponent, {
      ...this.dialogService.getDialogConfig(),
    });

    dialogRef.afterClosed().subscribe(({ data }: any) => {
      const response =
        typeof data !== 'undefined' &&
        data !== null &&
        typeof data.id !== 'undefined'
          ? data
          : null;

      if (response !== null) {
        // show success stuff and reload data
        let message =
          'Solicitarea dvs cu numarul ' +
          response.id +
          '/' +
          response.date +
          ' a fost trimisa cu succes. ';
        // this.notificationService.warningSwal(
        //     this.successTitle, message, this.successIcon
        // );
      }
    });
  }

  renderDT() {
    this.isLoading = true;
    this.dtOptions = {
      serverSide: true, // Set the flag
      ajax: (dataTablesParameters: any, callback: any) => {
        // Adding custom parameters to the dataTablesParameters object
        dataTablesParameters.param1 = 'value1';
        dataTablesParameters.param2 = 'value2';
        dataTablesParameters.param3 = 'value3';

        this.http
          .post<DataTablesResponse>(
            this.dtLink, // datatable link, we need this
            dataTablesParameters // parameters for filtering, send here
          )
          .subscribe((resp: any) => {
            this.isLoading = false;
            callback({
              recordsTotal: resp.data.recordsTotal,
              recordsFiltered: resp.data.recordsFiltered,
              data: resp.data.data,
            });
          });
      },
      language: environment.config.romanianLanguageDataTable,
      columns: [
        {
          title: 'ID',
          data: 'id',
        },
        {
          title: 'Denumire',
          data: 'name',
        },
        {
          title: 'Slug',
          data: 'slug',
        },
        {
          title: 'Actiuni',
          orderable: false,
          render: () => {
            return `
              <button class="action-btn edit">
                <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
              </button>
              <button class="action-btn delete">
                <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
              </button>
            `;
          },
        },
      ],
      dom: 'Bfrtip',
      buttons: [
        {
          text: 'Active',
          key: '1',
          action: () => {
            // this.departmentService.getActiveDepartment().subscribe(() => {
            /* TO DO --> filter table and call get active sections */
            // });
          },
        },
        {
          text: 'Public',
          key: '2',
          action: () => {
            // this.departmentService.getPublicDepartment().subscribe(() => {
            /* TO DO --> filter table and call get public sections */
            // });
          },
        },
      ],
      rowCallback: (row: Node, data: any[] | any) => {
        const lastTd = (row as HTMLElement).querySelector('td:last-child');
        const editIcon = lastTd?.querySelector('.edit');
        const deleteIcon = lastTd?.querySelector('.delete');

        if (editIcon) {
          editIcon.addEventListener('click', () => {
            this.openEditDialog(data);
          });
        }

        if (deleteIcon) {
          deleteIcon.addEventListener('click', () => {
            const { id } = data;
            this.deleteSection(id);
          });
        }

        return row;
      },
    };
  }

  openEditDialog(data: Section) {
    const dialogRef = this.dialog.open(EditSectionComponent, {
      ...this.dialogService.getDialogConfig(),
      data,
    });

    dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
      if (success) {
        this.rerenderDT();
      }
    });
  }

  rerenderDT(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next('');
    });
  }
  deleteSection(sectionId: number) {
    Swal.fire({
      title: 'Sunteti sigur?',
      text: 'Nu o sa puteti recupera datele odata cu stergerea lor!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Confirm!',
      cancelButtonText: 'Cancel',
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // this.departmentService.deleteDepartment(sectionId).subscribe(() => {
        //   this.rerenderDT();
        //   Swal.fire({
        //     title: 'Sters!',
        //     text: 'Status sters cu succes.',
        //     icon: 'success',
        //     confirmButtonText: 'OK',
        //   });
        // });
      }
    });
  }
}
